<template>
	<el-dropdown>
		<span class="user">
			<el-avatar :src="userInfo.avatar_url ? userInfo.avatar_url : ''"></el-avatar>
			<label style="cursor: pointer">{{ userInfo.name ? userInfo.name : '' }}</label>
		</span>
		<template #dropdown>
			<el-dropdown-menu>
				<el-dropdown-item @click="goUserInfo"> 个人中心</el-dropdown-item>
				<el-dropdown-item @click="goOperatingManual"> 使用手册</el-dropdown-item>
				<el-dropdown-item @click="clearCache"> 清除缓存</el-dropdown-item>
				<el-dropdown-item @click="onLogout">退出</el-dropdown-item>
			</el-dropdown-menu>
		</template>
	</el-dropdown>
</template>

<script setup>
// Props
const props = defineProps({
	userInfo: {
		type: Object,
		default: () => ({})
	}
})

// Emits
const emit = defineEmits(['go-user-info', 'go-operating-manual', 'clear-cache', 'logout'])

// Methods
const goUserInfo = () => {
	emit('go-user-info')
}

const goOperatingManual = () => {
	emit('go-operating-manual')
}

const clearCache = () => {
	emit('clear-cache')
}

const onLogout = () => {
	emit('logout')
}
</script>

<style scoped lang="scss">
.user {
	display: flex;
	align-items: center;
	cursor: pointer;

	label {
		margin-left: 8px;
	}
}
</style>
